// src/App.jsx
import React, { useContext, useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Tabs from './components/Tabs';
import { ThemeContext } from './contexts/ThemeContext';
import { AcademicCapIcon } from '@heroicons/react/24/outline'; // Importing Heroicon

function App() {
  const { theme } = useContext(ThemeContext);
  const [selectedTopic, setSelectedTopic] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('selected_topic') || '';
    }

    return '';
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (selectedTopic) {
      localStorage.setItem('selected_topic', selectedTopic);
    } else {
      localStorage.removeItem('selected_topic');
    }
  }, [selectedTopic]);

  return (
    <div className={theme === 'dark' ? 'dark' : ''}>
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-300">
        <Navbar setSelectedTopic={setSelectedTopic} selectedTopic={selectedTopic} />
        
        {selectedTopic ? (
          <Tabs selectedTopic={selectedTopic} />
        ) : (
          <div className="flex flex-col items-center justify-center mt-10 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md mx-4 sm:mx-0">
            <AcademicCapIcon className="h-12 w-12 text-blue-500 dark:text-blue-400 mb-4 animate-pulse" />
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
              Select a Topic to Get Started
            </h2>
            <p className="text-gray-600 dark:text-gray-400 text-center max-w-md">
              Choose a topic from the navbar above to explore related content and features.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
